import { Box } from '@mui/material';
import { PLATE_FEATHER } from 'features/ui';
import { PageTitle } from './PageTitle';
import { CONTENT_MAX_WIDTH, pageGutterX, SHELL_GAP } from './shellGeometry';
import { useRouteTitle } from './useRouteTitle';

/** Desktop content header: the single page `h1`. */
export const PageHeader = () => {
  const title = useRouteTitle();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        maxWidth: CONTENT_MAX_WIDTH,
        ...pageGutterX,
        pl: { xs: 2, md: `${String(SHELL_GAP)}px` },
        pt: 2.5,
        pb: `${String(16 - PLATE_FEATHER)}px`,
      }}
    >
      <PageTitle title={title} fontSize={28} />
    </Box>
  );
};
